<a href="javascript:void(0)" alt="View Settings" class="nav-link pointer"
  (click)="openDisplaySettings(displaySettings)">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings-2 me-1">
    <path d="M20 7h-9" />
    <path d="M14 17H5" />
    <circle cx="17" cy="17" r="3" />
    <circle cx="7" cy="7" r="3" />
  </svg>
  View Conversion Parameters
</a>
<ng-template #displaySettings let-offcanvas>
  <div class="offcanvas-header border-bottom py-3">
    <h5 class="offcanvas-title">Conversion Parameters</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.close('Close click')"></button>
  </div>

  <div class="offcanvas-body p-0 d-flex flex-column">

    <!-- Scope strip (always visible, above tabs) -->
    <div class="conv-scope-strip">
      <span class="conv-scope-label">Include</span>
      <div class="form-check form-switch m-0">
        <input class="form-check-input"
               type="checkbox"
               id="includeIndexValue"
               [(ngModel)]="includedIndex"
               [ngModelOptions]="{standalone: true}"
               (change)="onIncludeIndex($event, includedIndex)">
        <label class="form-check-label small" for="includeIndexValue">Index Value</label>
      </div>
      <div class="form-check form-switch m-0">
        <input class="form-check-input"
               type="checkbox"
               id="includeMarketValue"
               [(ngModel)]="includedMarket"
               [ngModelOptions]="{standalone: true}"
               (change)="onIncludeMarket($event, includedMarket)">
        <label class="form-check-label small" for="includeMarketValue">Market Value</label>
      </div>
    </div>

    <!-- Tabs -->
    <ul class="nav nav-tabs px-3 pt-2 conv-tabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button type="button"
                class="nav-link"
                [class.active]="activeTab === 'units'"
                (click)="activeTab = 'units'">
          Units
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button type="button"
                class="nav-link"
                [class.active]="activeTab === 'currencies'"
                (click)="activeTab = 'currencies'">
          Currencies
        </button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="previousTender">
        <button type="button"
                class="nav-link"
                [class.active]="activeTab === 'comparison'"
                (click)="activeTab = 'comparison'">
          Comparison
        </button>
      </li>
    </ul>

    <!-- Tab content -->
    <div class="conv-tab-content flex-grow-1 p-3 bg-light">
      <div [hidden]="activeTab !== 'units'">
        <jft-revision-units-conversion
          (onSetUnitsDefault)="setUnitsDefault($event)"
          (onSetCustomUnit)="onCustomUnit($event)"
          [currencies]="currencies"
          [customUnits]="customUnits"
          [baseUnit]="baseUnit">
        </jft-revision-units-conversion>
      </div>
      <div [hidden]="activeTab !== 'currencies'">
        <jft-revision-currencies-conversion
          [currencies]="currencies"
          [conversionFactor]="conversionFactor"
          [tender]="tender"
          [baseCurrency]="baseCurrency"
          (onUpdateExchangeRates)="updateExchangeRates($event)"
          (onSetCustomCurrency)="onCustomCurrency($event)">
        </jft-revision-currencies-conversion>
      </div>
      <div [hidden]="activeTab !== 'comparison'" *ngIf="previousTender">
        <jft-revision-tenders-comparison
          [previousTender]="previousTender"
          [tender]="tender"
          [baseCurrency]="baseCurrency"
          [baseUnit]="baseUnit"
          (onBaseCurrencyChange)="baseCurrencyChange($event)"
          (onBaseUnitChange)="baseUnitChange($event)">
        </jft-revision-tenders-comparison>
      </div>
    </div>

  </div>

  <div class="modal-footer bg-white border-top py-2 px-3">
    <button type="button" class="btn btn-outline-secondary btn-sm me-2" (click)="offcanvas.close('Close click')">
      Cancel
    </button>
    <button type="button" class="btn btn-dark btn-sm" (click)="offcanvas.close('Done click')">
      Done
    </button>
  </div>
</ng-template>
